import { render, staticRenderFns } from "./DeleteTopicTemplate.vue?vue&type=template&id=1e14eee2&scoped=true"
import script from "./DeleteTopicTemplate.vue?vue&type=script&lang=js"
export * from "./DeleteTopicTemplate.vue?vue&type=script&lang=js"
import style0 from "./DeleteTopicTemplate.vue?vue&type=style&index=0&id=1e14eee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e14eee2",
  null
  
)

export default component.exports